import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { extractApiError } from '../../../../core/utils/api-format';
import { QuotaService } from '../../services/quota.service';
import { ApplicationItem } from '../../models/application.interface';
import { ApplicationCardComponent } from '../../components/application-card/application-card.component';
import { QuotaHeaderComponent } from '../../components/quota-header/quota-header.component';

@Component({
  selector: 'app-my-applications',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, ApplicationCardComponent, QuotaHeaderComponent],
  templateUrl: './my-applications.component.html',
  styleUrls: ['./my-applications.component.css']
})
export class MyApplicationsComponent implements OnInit {
  private quotaService = inject(QuotaService);

  applications: ApplicationItem[] = [];
  loading = true;
  error: string | null = null;
  page = 1;
  size = 15;
  totalPages = 0;
  totalElements = 0;

  ngOnInit(): void {
    this.loadMyApplications();
  }

  loadMyApplications(): void {
    this.loading = true;
    this.error = null;

    this.quotaService.getMyApplications(this.page, this.size).subscribe({
      next: (response) => {
        this.applications = response.res.content;
        this.totalPages = response.res.totalPages;
        this.totalElements = response.res.totalElements;
        this.loading = false;
      },
      error: (err) => {
        this.error = this.extractErrorMessage(err);
        this.loading = false;
        console.error('Ошибка загрузки заявок:', err);
      }
    });
  }

  private extractErrorMessage(err: any): string {
    return extractApiError(err?.error, 'Не удалось загрузить заявки');
  }

  retry(): void {
    this.loadMyApplications();
  }
}
